import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AdacodeConfigService} from "./adacode-config.service";
import {ADACodeConfigModel} from '../../../models/configuration/ADA-code-config.model';
@Component({
    selector: 'app-adacode-config',
    templateUrl: './adacode-config.component.html',
    styleUrls: ['./adacode-config.component.scss']
})
export class ADAcodeConfigComponent implements  OnInit
{


  isNeedSurface: boolean = false;
  isNeedsNarrative: boolean = false;
  isNeedsXray: boolean = false;
  txtCode: string = 'New Code';

  isNewVisible: boolean = true;
  isEditVisible: boolean = true;
  isSaveVisible: boolean = false;
  isCancelVisible: boolean = false;

  isDataEditDissabled: boolean = true;
  selectedRowData: ADACodeConfigModel = new ADACodeConfigModel();



  listOfCodes = [{ Code: "D0140", isNeedsSurface: true, isNeedsNarrative: false, isNeedsXray: false, isMayNeedReferral: false },
     { Code: "D0240", isNeedsSurface: true, isNeedsNarrative: false, isNeedsXray: false, isMayNeedReferral: false }];


  constructor(
    private cd: ChangeDetectorRef,
    private dataService :  AdacodeConfigService
  ) {}

  ngOnInit(): void {


    this.dataService.getApplicationProcedures().subscribe(res => {
      this.listOfCodes= res;
      this.selectedRowData = this.listOfCodes[0];
    },
      error => {
      console.log(error);

      }
      );

  }

    onValueChanged(e) {
        console.log(e);
    }

    onButtonActioClick(e)  {


        const act = e.component.element().id;

        switch ( act )
        {
        case 'btnNew':
            this.isNewVisible = false;
            this.isEditVisible = false;
            this.isSaveVisible = true;
            this.isDataEditDissabled = false;
            this.isCancelVisible = true;
            this.newItem();
            break;
        case 'btnEdit':
            this.isNewVisible = false;
            this.isEditVisible = false;
            this.isSaveVisible = true;
            this.isDataEditDissabled = false;
            this.isCancelVisible = true;


            break;
        case 'btnSave':
            this.saveItem();

            this.isNewVisible = true;
            this.isEditVisible = true;
            this.isSaveVisible = false;
            this.isDataEditDissabled = true;
            this.isCancelVisible = false;



            break;
          case 'btnCancel':
            this.isNewVisible = true;
            this.isEditVisible = true;
            this.isSaveVisible = false;
            this.isDataEditDissabled = true;
            this.isCancelVisible = false;

            break;


        }

    }

  onCodeItemClock(e) {
      this.selectedRowData=e.itemData;

  }

  newItem()  {

    this.selectedRowData = new ADACodeConfigModel();
    this.selectedRowData.Code="NEW";
    this.selectedRowData.isNeedsSurface = false;
    this.selectedRowData.isNeedsNarrative = false;
    this.selectedRowData.isNeedsXray = false;
    this.selectedRowData.isMayNeedReferral = false;

    this.cd.detectChanges();
    console.log("new", this.selectedRowData);

  }

  saveItem() {

      console.log("save", this.selectedRowData);


      const a = this.listOfCodes.find(f=>f.Code == this.selectedRowData.Code);
      if(a) {
        a.isNeedsSurface = this.selectedRowData.isNeedsSurface;
        a.isNeedsNarrative = this.selectedRowData.isNeedsNarrative;
        a.isNeedsXray = this.selectedRowData.isNeedsXray;
        a.isMayNeedReferral = this.selectedRowData.isMayNeedReferral;
      }
      else
      {
        this.listOfCodes.push({ Code : this.selectedRowData.Code ,isNeedsSurface: this.selectedRowData.isNeedsSurface ,
              isNeedsNarrative: this.selectedRowData.isNeedsNarrative, isNeedsXray: this.selectedRowData.isNeedsXray, isMayNeedReferral: this.selectedRowData.isMayNeedReferral });
      }

      // call api to save to server
    this.dataService.saveApplicationProcedures(this.selectedRowData).subscribe(res => {
        console.log(res);
      },
      error => {
        console.log(error);
      }
    );

  }


}
